import Component from '../core/Component'
import support from '../utils/BrowserSupport'
import { toggleClass } from '../utils/dom'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active',
    STATIC: 'is-static',
    SOON: 'is-openingSoon',
}

const defaults = {
    openingSoonText: '',
}

export default class PlanBubble extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            title: null,
            description: null,
        }

        this.timer = null

        this.isActive = false
        this.isPaused = false
    }

    prepare() {
        this.element.addEventListener(support.transitionEnd, () => {
            if (!this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })
    }

    destroy() {
        clearTimeout(this.timer)
    }

    set({ title = '', desc = '', color = '#A7ADB4', openingSoon = '' }) {
        if (openingSoon) {
            desc = desc ? desc + '\n' + this.options.openingSoonText : this.options.openingSoonText
        }

        this.setContent({
            title,
            desc,
        })

        this.element.style.color = color
        this.ref.title.style.backgroundColor = color

        return this
    }

    show(coords) {
        clearTimeout(this.timer)

        this.isActive = true

        if (!this.is(STATES.ACTIVE)) {
            this.element.classList.add(STATES.VISIBLE)
            this.element.offsetWidth
            this.element.classList.add(STATES.ACTIVE)
        }
    }

    hide() {
        this.timer = setTimeout(() => {
            this.isActive = false
            this.element.classList.remove(STATES.ACTIVE)
        }, 200)
    }

    move({ x, y }, force = false) {
        if (this.isPaused) {
            return
        }
        this.element.style.left = `${x}px`
        this.element.style.top = `${y}px`
    }

    pause() {
        this.isPaused = true
    }

    resume() {
        this.isPaused = false
        this.isActive = true
    }

    disableAnimation() {
        this.element.classList.add(STATES.STATIC)
    }

    enableAnimation() {
        this.element.classList.remove(STATES.STATIC)
    }

    setContent({ title = '', desc = '' }) {
        this.ref.title.textContent = title
        this.ref.description.innerHTML = desc
        return this
    }
}
